<template>
    <div class="viewcustomizer__wrapper">
        <div class="viewcustomizer__wrapper--buttons">
            <button
                v-for="(view, index) in views"
                :key="view + index"
                @click="activeView = index"
            >
                <img
                    :src="`${pluginPath}/icons/view/${view}.svg`"
                    :alt="
                        $translate(
                            'TatyouTheme::Template.categoriesCustomizeView'
                        )
                    "
                    :class="{ active: activeView == index }"
                />
            </button>
        </div>

        <p>{{ $translate("TatyouTheme::Template.categoriesCustomizeView") }}</p>
    </div>
</template>

<script>
import { setCookie, getCookie } from "../../../../../src/js/cookies";

export default {
    name: "ViewCustomizer",

    props: {
        mobileViews: {
            type: Array,
            required: true
        },

        desktopViews: {
            type: Array,
            required: true
        },

        itemClass: {
            type: String,
            required: true
        },

        containerId: {
            type: String,
            required: false
        },

        pluginPath: {
            type: String,
            required: true
        }
    },

    data: () => ({
        activeView: 0
    }),

    mounted() {
        const userSettings = getCookie("articlesperrow");

        let defaultIndex = 1;

        if (
            window.matchMedia("(min-width: 767px) and (max-width: 1199px)")
                .matches
        ) {
            defaultIndex = 0;
        }

        this.activeView = userSettings ?? defaultIndex;
    },

    computed: {
        isMobile() {
            return window.matchMedia("(max-width: 767px)").matches;
        },

        views() {
            if (!this.isMobile) {
                return this.desktopViews;
            }

            return this.mobileViews;
        }
    },

    methods: {
        customizeView() {
            setCookie("articlesperrow", this.activeView.toString());
            const itemsPerRow = this.views[this.activeView];

            // reorder items
            const items = document.querySelectorAll(`.${this.itemClass}`);

            if (this.containerId) {
                // container
                const container = document.getElementById(this.containerId);

                if (itemsPerRow > 4) {
                    container.classList.remove("container-max");
                    container.classList.add("px-3");
                } else {
                    container.classList.add("container-max");
                    container.classList.remove("px-3");
                }
            }

            for (const item of items) {
                item.className = `${this.itemClass} per-row-${itemsPerRow} ${
                    this.isMobile ? "mobile" : ""
                }`;
            }

            // setup image heights
            for (const container of document.querySelectorAll(
                ".category__produkt--bilder-container"
            )) {
                container.style.height = "auto";
                container.style.width = "auto";
            }
        }
    },

    watch: {
        activeView() {
            this.customizeView();
        }
    }
};
</script>